'use client'

import Link from 'next/link'
import { useEffect } from 'react'
import styled from '@emotion/styled'
import { colors } from '@/clients/styles/theme'
import { MonoButton } from '@/clients/components/atoms/Button'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // エラーをログに記録
    console.error(error)
  }, [error])

  return (
    <Container>
      <Title>_(┐「ε:)_ｽﾞｺｰ</Title>
      <Description>何かがうまくいかなかったようです。。。。</Description>
      <ButtonContainer>
        <RetryButton onClick={() => reset()}>もう一度試す</RetryButton>
        <Link href="/" locale={'ja'}>
          <BackButton>トップへ戻る</BackButton>
        </Link>
      </ButtonContainer>
    </Container>
  )
}

const Container = styled.div`
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  text-align: center;
`

const Title = styled.h1`
  font-weight: bold;
  text-align: center;
  font-size: 32px;
  color: ${colors.text.primary};
`

const Description = styled.div`
  font-weight: bold;
  text-align: center;
  font-size: 16px;
  color: ${colors.text.primary};
  margin-top: 16px;
  line-height: 2;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
`

const RetryButton = styled(MonoButton)`
  padding: 16px 32px;
`

const BackButton = styled(MonoButton)`
  padding: 16px 32px;
`